<template>
  <Teleport to="body">
    <div class="right_setBox">
      <div class="selectBox" @click.stop="changeClick">
        <img
          src="@/assets/images/icon/common/lang-icon.png"
          alt="language button"
        />
      </div>

      <Transition name="fade">
        <div v-if="clickLang" class="dropdown_box">
          <ul
            v-if="subPath === 'brief' || subPath === 'notice'"
            class="option"
          >
            <li
              v-for="option in availLang"
              :key="option.language"
            >
              <a
                :id="`globalChk_${option.language}`"
                :name="`globalChk_${option.language}`"
                :class="{ selected: selectLang === option.display }"
                @click.stop="choiceLang(option)"
              >
                {{ option.display }}
              </a>
            </li>
          </ul>

          <ul v-else class="option">
            <li
              v-for="option in filteredAvailLang"
              :key="option.language"
            >
              <a
                :id="`globalChk_${option.language}`"
                :name="`globalChk_${option.language}`"
                :class="{ selected: selectLang === option.display }"
                @click.stop="choiceLang(option)"
              >
                {{ option.display }}
              </a>
            </li>
          </ul>
        </div>
      </Transition>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, computed, watch, onMounted, defineProps } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

// Props
const props = defineProps({
  availLang: {
    type: Array,
    default: () => [],
  },
  langDisplay: {
    type: String,
    default: "",
  },
});


// Hooks
const route = useRoute();
const store = useStore();

// Local State
const selectLang = ref(props.langDisplay);

// Computed
const clickLang = computed(() => store.state.board.clickLang);
const subPath = computed(() => route.path.split("/")[2]);
const filteredAvailLang = computed(() => 
  props.availLang.filter((option) => option.language !== "ru")
);

// console.log('filteredAvailLang', filteredAvailLang)

// Methods (Vuex Mutations & Actions)
const changeLang = (payload) => store.commit("board/changeLang", payload);
const langClick = (payload) => store.commit("board/langClick", payload);
const changeDisplay = (payload) => store.commit("board/changeDisplay", payload);
const changeLoadBrief = (payload) => store.commit("board/changeLoadBrief", payload);
const getAibriefTitleList = () => store.dispatch("board/getAibriefTitleList");

// Actions
const choiceLang = (event) => {
  selectLang.value = event.display;
  changeLang(event);
  
  if (subPath.value === "ai-brief") {
    getAibriefTitleList();
    changeLoadBrief({ state: false });
  }
  langClick({ state: false }); // 드롭박스 닫기
};

const changeClick = () => {
  langClick({ state: !clickLang.value });
};

// Lifecycle
onMounted(() => {
  changeDisplay(selectLang.value);
});

// Watchers
watch(subPath, (newVal) => {
  if (newVal === "ai-brief" && selectLang.value === "Русский") {
    changeDisplay("Language");
    localStorage.setItem("userLang", "Language");
    localStorage.setItem("patchLang", "default");
    selectLang.value = "Language";
  }
});
</script>

<style scoped>
.right_setBox {
  position: fixed;

  /* 헤더 오른쪽 위치 */
  top: 12px;
  right: 16px;

  z-index: 10000;
}

.right_setBox .selectBox {
  position: relative;
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 8px;
  background: var(--Menu-Dark);
  cursor: pointer;
}

.right_setBox .selectBox img {
  width: 20px;
  height: 20px;
}

.right_setBox .dropdown_box {
  position: absolute;
  top: 48px;
  right: 0;

  width: 120px;
  max-height: 240px;
  padding: 10px;

  box-sizing: border-box;
  border: 1px solid #2c2c2c;
  border-radius: 8px;

  background: var(--Menu-Dark);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);

  z-index: 10001;
}

.right_setBox .dropdown_box ul {
  display: flex;
  flex-direction: column;

  width: 100%;
  max-height: 210px;

  padding: 0;
  margin: 0;

  overflow-y: auto;
  list-style: none;
}

.right_setBox .dropdown_box ul li {
  width: 100%;
  margin-bottom: 2px;
}

.right_setBox .dropdown_box ul li:last-child {
  margin-bottom: 0;
}

.right_setBox .dropdown_box ul li a {
  display: flex;
  align-items: center;

  width: 100%;
  height: 36px;
  padding: 0 25px 0 10px;

  box-sizing: border-box;
  border-radius: 4px;

  color: var(--txt-gray-color);
  font-family: Poppins, sans-serif;
  font-size: 13px;
  font-weight: 400;
  text-transform: capitalize;

  cursor: pointer;
}

.right_setBox .dropdown_box ul li a:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.right_setBox .dropdown_box ul li a.selected {
  color: var(--primary-color) !important;
  font-weight: 700 !important;

  background:
    url("@/assets/images/icon/common/check-orange.png")
    right 5px center / 16px no-repeat !important;
}

.fade-enter-active,
.fade-leave-active {
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
</style>